/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import { applicationModelNames } from 'client/util/Constants/ApplicationConstants';
import ApplicationTemplateApi from 'client/api/v2/ApplicationTemplateApiV2';
import ApplicationTemplatesFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/ApplicationTemplatesFilters';
import CollectionModule from 'client/store/modules/CollectionModule';
import Vue from 'vue';

const { SAML2, BOOKMARK, OIDC } = applicationModelNames;

export class ApplicationTemplateCollectionClass extends CollectionModule {
  constructor(Api = ApplicationTemplateApi, idField = '_id', sortBy = 'name') {
    super(Api, idField, sortBy);
  }

  getInitialState() {
    const state = super.getInitialState();
    state.features.items.filters = [
      ApplicationTemplatesFilters.appStatusEos(),
      ApplicationTemplatesFilters.appStatusEol(),
    ];
    return {
      ...state,
      genericBookmarkId: '',
      genericTemplateId: '',
      genericOidcTemplateId: '',
    };
  }

  extractModule() {
    const module = super.extractModule();

    module.actions.fetchGenericTemplate = (...params) => this
      .fetchGenericTemplate(...params);

    module.actions.fetchGenericBookmark = (...params) => this
      .fetchGenericBookmark(...params);

    module.actions.fetchGenericOidcTemplate = this.fetchGenericOidcTemplate.bind(this);

    module.getters.genericBookmarkId = (...params) => this
      .genericBookmarkId(...params);

    module.getters.genericTemplateId = (...params) => this
      .genericTemplateId(...params);

    module.getters.genericOidcTemplateId = this.genericOidcTemplateId.bind(this);

    module.mutations.SET_BOOKMARK_TEMPLATE_ID = (...params) => this
      .SET_BOOKMARK_TEMPLATE_ID(...params);

    module.mutations.SET_GENERIC_TEMPLATE_ID = (...params) => this
      .SET_GENERIC_TEMPLATE_ID(...params);

    module.mutations.SET_GENERIC_OIDC_TEMPLATE_ID = this.SET_GENERIC_OIDC_TEMPLATE_ID.bind(this);

    return module;
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  async fetchGenericTemplate({ state, commit }) {
    if (state.genericTemplateId === '') {
      let item;
      const { results } = await this.Api.fetch(0, 5, 'name', SAML2);
      if (results.length) {
        item = results.find(({ name }) => name === SAML2);
      }

      if (item) {
        commit('SET_GENERIC_TEMPLATE_ID', item[this.idField]);
        commit('SET_ITEM', item);
      }
    }
  }

  async fetchGenericBookmark({ state, commit }) {
    if (state.genericBookmarkId === '') {
      let item;
      const { results } = await this.Api.fetch(0, 5, 'name', BOOKMARK);

      if (results.length) {
        item = results.find(({ name }) => name === BOOKMARK);
      }

      if (item) {
        commit('SET_BOOKMARK_TEMPLATE_ID', item[this.idField]);
        commit('SET_ITEM', item);
      }
    }
  }

  async fetchGenericOidcTemplate({ commit, state }) {
    if (!state.genericOidcTemplateId) {
      const { results } = await this.Api.fetch(0, 1, 'name', OIDC);

      if (results.length) {
        const [item] = results;

        commit('SET_GENERIC_OIDC_TEMPLATE_ID', item[this.idField]);
        commit('SET_ITEM', item);
      }
    }
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  genericTemplateId({ genericTemplateId }) {
    return genericTemplateId;
  }

  genericBookmarkId({ genericBookmarkId }) {
    return genericBookmarkId;
  }

  genericOidcTemplateId({ genericOidcTemplateId }) {
    return genericOidcTemplateId;
  }

  // --------------------------------------------------------------------------
  // Mutations
  // --------------------------------------------------------------------------

  SET_FILTER(state, { filter }) {
    const { filters } = state.features.items;
    filters.forEach((fil, index) => {
      if (fil.id === filter.id) {
        Vue.set(state.features.items.filters, index, filter);
      }
    });
  }

  SET_GENERIC_TEMPLATE_ID(state, id = '') {
    state.genericTemplateId = id;
  }

  SET_BOOKMARK_TEMPLATE_ID(state, id = '') {
    state.genericBookmarkId = id;
  }

  SET_GENERIC_OIDC_TEMPLATE_ID(state, id = '') {
    state.genericOidcTemplateId = id;
  }
}

export default new ApplicationTemplateCollectionClass().extractModule();
